module.exports = __webpack_public_path__ + "static/media/Accademia - Bordeaux_PW Pink.5d009e95.jpg";